module.exports = __webpack_public_path__ + "img/ios.6cc2140d.svg";